// ============================================
// UPSELL SLIDER - MAIN INIT FUNCTION
// ============================================
// function initUpsellSlider() {
//   if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
//     return false;
//   }

//   var $slider = jQuery('.js-cart-upsell-slider');
//   if (!$slider.length) return;

//   // Skip if already initialized
//   if ($slider.hasClass('slick-initialized')) return;

//   $slider.slick({
//     slidesToShow: 2,
//     slidesToScroll: 1,
//     arrows: true,
//     dots: false,
//     infinite: true,
//     speed: 300,
//     autoplay: false,
//     draggable: true,
//     touchMove: true,
//     responsive: [
//       {
//         breakpoint: 768,
//         settings: { slidesToShow: 1 }
//       }
//     ]
//   });

//   console.log('✅ Upsell slider initialized with fresh settings');
// }

// // ============================================
// // INIT ON READY — once only
// // ============================================
// jQuery(document).ready(function() {
//   setTimeout(initUpsellSlider, 600);
// });






function initUpsellSlider() {
  if (typeof jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
    return false;
  }

  var $slider = jQuery('.js-cart-upsell-slider');
  if (!$slider.length) return;

  // Destroy existing broken instance first
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  $slider.slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    speed: 300,
    autoplay: false,
    draggable: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1 }
      }
    ]
  });

  // Force recalculate after init to fix wrong dimension issue
  setTimeout(function() {
    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('setPosition');
    }
  }, 100);

  console.log('Upsell slider initialized');
}

jQuery(document).ready(function() {

  // Initial load
  setTimeout(initUpsellSlider, 600);

  // Watch for cart DOM updates and re-init if needed
  setInterval(function() {
    var $slider = jQuery('.js-cart-upsell-slider');
    if ($slider.length && !$slider.hasClass('slick-initialized')) {
      console.log('Reinitializing Upsell Slider...');
      initUpsellSlider();
    }
  }, 100);

  // Drawer open via header cart button
  jQuery(".cart-drawer .header-actions__action").click(function() {
    initUpsellSlider();
  });

  // KEY FIX: Watch dialog element for 'open' attribute (Horizon theme specific)
  // When product is added to cart, dialog gets 'open' attribute added
  var dialogObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
        var $target = jQuery(mutation.target);
        // Check if this is the cart drawer dialog
        if ($target.hasClass('cart-drawer__dialog')) {
          // Dialog just opened - reinit slider after transition completes
          setTimeout(initUpsellSlider, 350);
        }
      }
    });
  });

  // Observe the cart drawer dialog element
  var cartDialog = document.querySelector('.cart-drawer__dialog');
  if (cartDialog) {
    dialogObserver.observe(cartDialog, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

});